(() => {
  const selector = '.shopify-app-block a[href*="apps.shopify.com/eu-widerrufsbutton"]'

  const removeWatermark = (root = document) => {
    const links = []
    if (root instanceof Element && root.matches(selector)) links.push(root)
    if (root.querySelectorAll) links.push(...root.querySelectorAll(selector))

    links.forEach((link) => {
      const watermark = link.parentElement
      if (watermark) watermark.remove()
      else link.remove()
    })
  }

  const init = () => {
    removeWatermark()

    const observer = new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach((node) => {
          if (node instanceof Element) removeWatermark(node)
        })
      })
    })

    observer.observe(document.body, { childList: true, subtree: true })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true })
  } else {
    init()
  }
})()
